import { signal, WritableSignal } from '@angular/core';
import { TenantCandidateDto } from '@app/core/data/http/dtos';

export class TenantModel {
  public tenantId: WritableSignal<string>;
  public tenantSlug: WritableSignal<string>;
  public displayName: WritableSignal<string>;

  constructor() {
    this.tenantId = signal<string>('');
    this.tenantSlug = signal<string>('');
    this.displayName = signal<string>('');
  }

  public static fromDto(dto: TenantCandidateDto): TenantModel {
    const candidate = new TenantModel();
    candidate.tenantId.set(dto?.tenantId || '');
    candidate.tenantSlug.set(dto?.tenantSlug || '');
    candidate.displayName.set(dto?.displayName || dto?.tenantSlug || dto?.tenantId || '');
    return candidate;
  }

  public static fromDtos(dtos: TenantCandidateDto[] | undefined | null): TenantModel[] {
    if (!Array.isArray(dtos) || dtos.length === 0) {
      return [];
    }

    return dtos.map((dto) => TenantModel.fromDto(dto));
  }
}
